export const DELIMITERS = [
  { name: 'Comma (,)', value: ',' },
  { name: 'Tab (\\t)', value: '\t' },
  { name: 'Semicolon (;)', value: ';' },
  { name: 'Pipe (|)', value: '|' },
  { name: 'Colon (:)', value: ':' },
  { name: 'Space ( )', value: ' ' },
  // { name: 'Custom Delimiter', value: 'Custom' }, // Add custom delimiter
];

export const DATE_FORMATS = [
  "dd-mm-yyyy",
  "mm-dd-yyyy",
  "dd/mm/yyyy",
  "mm/dd/yyyy",
  "yyyy-mm-dd",
  "yyyy/mm/dd",
  "yyyy-dd-mm",
  "yyyy/dd/mm",
];
